import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.order',
            allOrders: null
        }
    },

    methods: {
        process(order) {
            return axios({
                method: 'post',
                url: route('api.orders.process', order)
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                    return Promise.reject(response.data.message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        },

        show(order) {
            return axios({
                method: 'get',
                url: route('api.orders.show', order)
            })
            .then(response => response.data.data)
        },

        all() {
            if(this.allOrders) {
                return Promise.resolve(this.allOrders)
            }

            return axios({
                method: 'get',
                url: route('api.orders.index'),
                params: {
                    scopes: ['allRecords'],
                }
            })
            .then(response => {
                this.$set(this, 'allOrders', response.data.data.data)
                return this.allOrders
            })
        }
    }
}